module.exports = __webpack_public_path__ + "ac5b7e64c5efdab7dfc7f7e697239744.jpg";